(function ( $ ) {
    var specialSelectorSearchAjax = {};
    $.fn.getObject = function(onSuccess, onError) {
        const returnPromise = !onSuccess;

        const fn = () => {
            const elm = $(this);

            var v = parseInt($(this).val());
            if(v < 1 || elm[0].ajaxParams == undefined) {
                return null;
            } else {
                var params = elm[0].ajaxParams;
                params['data']['id'] = v;

                params.success = function(data) {
                    if(typeof data == 'object') {
                        onSuccess(data);
                    } else if(onError) {
                        onError();
                    }
                };

                if(onError) {
                    params.fail = onError;
                }

                var add_str = '?';
                if(params.url.split('?').length > 1) {
                    add_str = '&';
                }
                params.url = params.url + add_str + 'get_object=true';


                specialSelectorSearchAjax = $.ajax(params);
            }
        }
        if (returnPromise) {
            return new Promise((resolve, reject) => {
                onSuccess = resolve;
                onError = reject;
                fn();
            })
        }
        else {
            fn();
        }
        return this;
    };

}( jQuery ));
